import React from "react";

const holder = {
  closePropertySelector(e) {
    if (
      holder.containerRef &&
      !holder.containerRef.current?.contains(e.target)
    ) {
      holder.outlet({ selectedIds: holder.selectedIds });
      holder.internalStateSetter("isOpen", false);
      document.removeEventListener("mousedown", holder.closePropertySelector);
    }
  },
};

export default {
  "SimpleMultiSelector.Wrapper.Header": async (
    { isOpen, containerRef, isReadonly, inputRef, selectedIds },
    outlet,
    internalStateSetter
  ) => {
    if (isReadonly) return;
    if (isOpen) return;
    await internalStateSetter("isOpen", true);

    let newContainerRef = containerRef;
    let newInputRef = inputRef;

    if (!containerRef || !inputRef) {
      newContainerRef = React.createRef(null);
      newInputRef = React.createRef(null);
      await internalStateSetter({
        containerRef: newContainerRef,
        inputRef: newInputRef,
      });
    }

    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = newContainerRef;
    holder.outlet = outlet;
    holder.selectedIds = selectedIds;

    newInputRef?.current?.children?.[0]?.children?.[0]?.focus?.();

    document.addEventListener("mousedown", holder.closePropertySelector);
  },
  "SimpleMultiSelector.Wrapper.Header.SearchWrapper.SearchInput": (
    { value },
    _,
    internalStateSetter
  ) => {
    internalStateSetter({ searchTerm: value });
  },
  "SimpleMultiSelector.Wrapper.DropdownWrapper.BorderWrapper.ButtonsWrapper.ListWrapper.ButtonsWrapper.SelectedValueButton":
    ({ selectedPropertyId, selectedIds }, _, internalStateSetter) => {
      const newSelectedIds = [...selectedIds];
      const index = newSelectedIds.indexOf(selectedPropertyId);
      newSelectedIds.splice(index, 1);

      internalStateSetter({ selectedIds: newSelectedIds });
      holder.selectedIds = newSelectedIds;
    },
  "SimpleMultiSelector.Wrapper.Header.Button": (
    {},
    outlet,
    internalStateSetter
  ) => {
    outlet({ selectedIds: [] });
    internalStateSetter({ isOpen: false });
  },
  "SimpleMultiSelector.Wrapper.DropdownWrapper.BorderWrapper.ListWrapper.ListWrapper.OptionsList":
    ({ id, selectedIds, singleSelect }, outlet, internalStateSetter) => {
      if (singleSelect) {
        outlet({ selectedIds: [id] });
        internalStateSetter({ isOpen: false });
        document.removeEventListener("mousedown", holder.closePropertySelector);
        return;
      }
      const newSelectedIds = [...selectedIds];
      if (newSelectedIds.includes(id)) {
        const index = newSelectedIds.indexOf(id);
        newSelectedIds.splice(index, 1);
      } else {
        newSelectedIds.push(id);
      }

      internalStateSetter({ selectedIds: newSelectedIds });
      holder.selectedIds = newSelectedIds;
    },
  "SimpleMultiSelector.Wrapper.DropdownWrapper.BorderWrapper.ClearAllHeader.ClearAll":
    ({ selectedIds, properties }, _, internalStateSetter) => {
      if (selectedIds.length > 0) {
        internalStateSetter({ selectedIds: [] });
        holder.selectedIds = [];
      } else {
        internalStateSetter({ selectedIds: properties.map((p) => p.id) });
        holder.selectedIds = properties.map((p) => p.id);
      }
    },
};
